import { render, staticRenderFns } from "./the-settings-container.vue?vue&type=template&id=680d72ed&"
import script from "./the-settings-container.vue?vue&type=script&lang=js&"
export * from "./the-settings-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports